import { Attachement } from '../models/shared/Attachment'
import { formatDate } from '../utils/date'
import { AdvancedButton } from './AdvancedButton'
import { useText } from '../context/TextContext'
import DropdownConfirm from './DropdownConfirm'

interface Props {
    attachment: Attachement
    onDelete: () => Promise<void>
    readonly?: boolean
    onPreview?: () => void
}

export default function DealAttachmentRecord(props: Props) {
    const { attachment, onPreview } = props
    const text = useText();
    const downloadUrl = attachment.url;

    const isImage = attachment.fileType?.startsWith('image')

    const handlePreviewClick = (e: React.MouseEvent) => {
        e.preventDefault()
        if (onPreview) {
            onPreview()
        } else {
            // Fallback to opening in new tab if no preview handler
            window.open(downloadUrl, '_blank', 'noreferrer')
        }
    }

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            if (onPreview) {
                onPreview()
            } else {
                // Fallback to opening in new tab if no preview handler
                window.open(downloadUrl, '_blank', 'noreferrer')
            }
        }
    }

    return (
        <div className='d-flex gap-2'>

            <div
                className='deal-img-preview center'
                onClick={handlePreviewClick}
                style={{ cursor: 'pointer' }}
                role="button"
                tabIndex={0}
                onKeyDown={handleKeyDown}
            >
                {isImage && downloadUrl !== '/'
                    ? <img className='rounded' src={downloadUrl} alt={attachment.name} />
                    : <i className='bi bi-file-earmark-text fs-1 text-primary' />
                }
            </div>

            <div className='d-flex flex-column justify-content-center'>
                <div className='small text-break'>{attachment.name}</div>
                <div className='text-muted small'>{formatDate(attachment.createdAt)}</div>
            </div>

            <div className='center ms-auto'>
                <a href={downloadUrl} download={attachment.name} target='_blank' rel='noreferrer'>
                    <AdvancedButton variant='clear' size='sm' icon='bi-download' />
                </a>
                {!props.readonly && <DropdownConfirm onConfirm={props.onDelete} header={text.deleteAttachement}>
                    <AdvancedButton variant='clear' size='sm' icon='bi-trash' />
                </DropdownConfirm>
                }
            </div>
        </div>
    )
}
